import React from "react";
import { Eleven } from "./Chart.config";
import ShreeDayTable from "./ShreeDayTable";

const ShreeDay = ({ chartData }) => {
   return <ShreeDayTable staticData={Eleven} chartData={chartData} />;
};

export default ShreeDay;
